const VECTOR_EXACT_PATHS = new Set([
  "/",
  "/ai",
  "/business",
  "/business/pricing",
  "/button",
  "/chrome-extension",
  "/competitive-monitoring",
  "/compliance-monitoring",
  "/contact",
  "/ecommerce",
  "/enterprise",
  "/finance",
  "/insurance",
  "/integrations",
  "/journalists",
  "/law-firms",
  "/pricing",
  "/regulatory-intelligence",
  "/saas-info-services",
  "/seo-change-monitoring",
  "/sign-up",
  "/website-defacement-monitoring",
]);

const VECTOR_BLOG_PATHS = new Set([
  "/blog/best-website-monitoring-tools-guide",
  "/blog/competitor-feature-release-tracker",
  "/blog/competitor-pricing-change-alerts",
  "/blog/horizon-scanning-regulatory-intelligence",
  "/blog/monitor-competitor-websites",
  "/blog/monitor-website-changes-api",
  "/blog/pricing-intelligence-guide",
  "/blog/regulatory-tracking-software",
  "/blog/retailer-price-monitoring-guide",
  "/blog/third-party-risk-management",
  "/blog/top-compliance-monitoring-tools",
  "/blog/top-free-competitive-intelligence-tools",
  "/blog/vendor-risk-management-software",
  "/blog/visualping-ai",
  "/blog/visualping-api-use-cases",
]);

export const VECTOR_SITE_ID = "4e9678fb-5956-4bd8-9c31-3ee346fc7976";
export const VECTOR_LOCALE = "en";

export const isVectorPixelEnabled = () => {
  return process.env["NEXT_PUBLIC_DISABLE_VECTOR_PIXEL"] !== "true";
};

export const shouldLoadVectorPixel = (path: string, locale?: string) => {
  if (locale !== VECTOR_LOCALE) {
    return false;
  }

  const pathname = normalizePathname(path);

  return VECTOR_EXACT_PATHS.has(pathname) || VECTOR_BLOG_PATHS.has(pathname);
};

const normalizePathname = (path: string) => {
  const pathname = path.split(/[?#]/)[0] || "/";

  if (pathname === "/") {
    return pathname;
  }

  return pathname.replace(/\/+$/, "");
};
